export const progress = (val, min, max) => {
    return (((val - min) / (max - min)) * 100).toFixed(2);
};
